import React, { Component } from 'react'
import { Doughnut } from 'react-chartjs-2'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import NoData from './noData'

const approvedColor = '#1ab394'
const declinedColor = '#ed5565'
const restartedColor = '#1c84c6'

const holdColor = '#f8ac59'
const completeColor = '#1ab394'
const reviewColor = '#1c84c6'
const netkiReviewColor = '#512D8C'

class TxStatusBreakDown extends Component {
  constructor(props) {
    super(props)
    this.state = {
      chartData: {},
      chartToggle: false,
      noData: false,
    }
  }

  renderCompletedSubcategory = () => {
    const { props } = this
    const { data } = props
    if (data) {
      const { aggregate } = data
      if (aggregate) {
        const { approved, declined, restarted } = aggregate.by_end_state
        const dataset = [approved, declined, restarted]
        const chartData = {
          labels: ['Approved', 'Declined', 'Restarted'],
          datasets: [
            {
              data: dataset,
              backgroundColor: [approvedColor, declinedColor, restartedColor],
            },
          ],
        }

        this.setState({ chartData })
      }
    }
  }

  renderHoldSubcategory = () => {
    const { props } = this
    const { data } = props
    if (data) {
      const { aggregate } = data
      if (aggregate) {
        const { sanctions, watch, face_match, liveness, netki_review } = aggregate.hold
        const dataset = [sanctions, watch, face_match, liveness, netki_review]
        const chartData = {
          labels: ['Sanction', 'AML', 'Face', 'Liveness', 'Netki Review'],
          datasets: [
            {
              data: dataset,
              backgroundColor: [approvedColor, declinedColor, holdColor, reviewColor, netkiReviewColor],
            },
          ],
        }

        this.setState({ chartData })
      }
    }
  }

  renderMain = () => {
    const { props } = this
    const { data } = props
    const { aggregate } = data
    if (aggregate) {
      const complete = Object.keys(aggregate.by_end_state).reduce((p, key) => p + aggregate.by_end_state[key], 0)
      const hold = Object.keys(aggregate.hold).reduce((p, key) => p + aggregate.hold[key], 0)

      const dataset = [complete, hold]
      const chartData = {
        labels: ['Completed', 'Hold'],
        datasets: [
          {
            data: dataset,
            backgroundColor: [completeColor, holdColor],
          },
        ],
      }
      if (dataset.filter((i) => i).length === 0) {
        this.setState({ noData: true })
      } else {
        this.setState({ noData: false })
        this.setState({ chartData })
      }
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { props } = this
    if (prevProps.data !== this.props.data) {
      if (props.data && props.data.transaction_data) {
        this.renderMain()
      }
    }
  }

  getElementsAtEvent = (elems) => {
    if (elems && elems.length) {
      if (this.state.chartToggle) {
        this.setState({ chartToggle: false })
        this.renderMain()
      } else {
        if (elems[0]._index === 0) {
          this.renderCompletedSubcategory()
        } else {
          this.renderHoldSubcategory()
        }
        this.setState({ chartToggle: true })
      }
    }
  }

  render() {
    return (
      <div className='ibox float-e-margins animated fadeIn'>
        <div className='ibox-title'>
          <h5>
            Status Breakdown For&nbsp;
            {this.props.timeSpan}
          </h5>
        </div>
        {this.state.noData && <NoData />}
        {!this.state.noData && (
          <div className='ibox-content' style={{ height: 350 }}>
            <Doughnut
              getElementsAtEvent={this.getElementsAtEvent}
              data={this.state.chartData}
              options={{
                maintainAspectRatio: false,
              }}
            />
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  isFetching: state.allMetrics.isFetching,
  errorMessage: state.allMetrics.errorMessage,
  data: state.allMetrics.results,
})

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TxStatusBreakDown))
